import * as React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';
import { BREAKPOINTS } from '@/constants';

function AutoVsOneHundred() {
  return (
    <DemoWrapper>
      <Demo
        initialValues={{
          margin: 0,
        }}
        outputWrapper={null}
        controlPosition="bottom"
        customGrid={{
          gridTemplateColumns: 'min(400px, 100%)',
          justifyContent: 'center',
        }}
        controls={[
          <DemoSliderControl
            key="margin"
            id="margin"
            label="Margin"
            min={0}
            max={64}
          />,
        ]}
      >
        {({ margin }) => {
          return (
            <Wrapper data-show-margin={margin > 0}>
              <Row>
                <Child
                  style={{ width: 'auto', marginInline: margin }}
                >
                  {`width: auto;`}
                </Child>
              </Row>
              <Row>
                <Child
                  style={{ width: '100%', marginInline: margin }}
                >
                  {`width: 100%;`}
                </Child>
              </Row>
            </Wrapper>
          );
        }}
      </Demo>
    </DemoWrapper>
  );
}

const DemoWrapper = styled.div`
  margin-inline: calc(var(--viewport-padding) * -1);
  padding-inline: var(--viewport-padding);

  @media (max-width: 53rem) {
    overflow: hidden;
  }
`;

const Wrapper = styled.div``;

const Row = styled.div`
  border-radius: 2px;

  ${Wrapper}[data-show-margin='true'] & {
    background: hsl(33deg 100% 75%);
  }

  &:first-child {
    margin-bottom: 16px;
  }
`;

const Child = styled.div`
  flex: 1;
  border: 2px solid var(--color-gray-700);
  border-radius: 5px;
  padding: 24px;
  font-family: var(--font-family-mono);
  background: var(--color-info-300);
`;

export default AutoVsOneHundred;
